import { EntityInstanceSearch, SearchFamillyData } from '90.quickConnect.Models/models';

const isInSelect = (idsAttributesSelect: string[], attributeId: string): boolean =>
  idsAttributesSelect && idsAttributesSelect.length > 0 && idsAttributesSelect.includes(attributeId);

const mapSearchValues = (mapped: EntityInstanceSearch[], idsAttributesSelect: string[]): SearchFamillyData[] => {
  const resultsMap: Map<string, SearchFamillyData> = new Map();
  const detailsMap: Map<string, string[]> = new Map();
  const selectedTitlesMap: Map<string, string[]> = new Map();
  const selectedValuesMap: Map<string, string[]> = new Map();

  mapped.forEach((res) => {
    const { instanceId } = res;
    const defaultResValue = res?.value ?? '';
    const defaultResTitle = res?.title ?? '';
    const { attributeId } = res;

    // Init SearchFamillyData if not exists yet
    if (!resultsMap.has(instanceId)) {
      resultsMap.set(instanceId, {
        id: res.id,
        schemaId: res.schemaId,
        entityInstanceId: instanceId,
        title: '',
        description: '',
        value: '',
      });
    }

    // Ajout dans la map des descriptions
    if (!detailsMap.has(instanceId)) detailsMap.set(instanceId, []);
    detailsMap.get(instanceId)?.push(defaultResValue);

    // Si attribut sélectionné
    if (isInSelect(idsAttributesSelect, attributeId)) {
      if (!selectedValuesMap.has(instanceId)) selectedValuesMap.set(instanceId, []);
      selectedValuesMap.get(instanceId)?.push(defaultResValue);

      if (idsAttributesSelect.length === 1) {
        // Titre direct
        resultsMap.get(instanceId)!.title = defaultResTitle;
      } else {
        if (!selectedTitlesMap.has(instanceId)) selectedTitlesMap.set(instanceId, []);
        selectedTitlesMap.get(instanceId)?.push(defaultResValue);
      }
    }
  });

  // résultat finale
  resultsMap.forEach((result, instanceId) => {
    result.title = result.title || (selectedTitlesMap.get(instanceId)?.join(' / ') ?? '');
    result.description = detailsMap.get(instanceId)?.join(' / ') ?? '';
    result.value = selectedValuesMap.get(instanceId)?.join(' / ') ?? '';
  });

  return Array.from(resultsMap.values());
};

export default mapSearchValues;
